module.exports = __webpack_public_path__ + "static/media/frames-10.15d5c7ca.jpg";